export default __webpack_public_path__ + "static/media/kitchen3-afterI-2048w.fbf4ccd0.png";